export enum PolicyCurency {
  GEL = '1',
  USD = '2',
  EUR = '3',
}

export enum PolicyCurencyType {
  GEL = 'GEL',
  USD = 'USD',
  EUR = 'EUR',
}

export enum PolicyCurencyTypeSymbol {
  GEL = '₾',
  USD = '$',
  EUR = '€',
}


export enum ProductId {
  MTPL = '1',
  property = '3',
  travel = '8',
}


export enum Statuses{
  FirstPmtShouldBePayed=1,
  PolicyCallOfToday,
  PolicyCallOfIn3Dayes,
  GracePeriodExpiredToday,
  TobePayedToday,
  TobePayedIn15dayes,
  Payed
}
export enum StatusesClass{
  FirstPmtPayed='firstPmtPayed',
  Debt='debt',
  GracePeriod='gracePeriod',
  TobePayed='tobePayed',
  Payed='payed'
}